import { AppUtils } from '../../../../../shared/utils/index';
import { Application } from '../../../../../shared/models/view/Application';
import { User } from "../../../../../shared/models/api/User/User";
import { DamageFormModel } from './DamageFormModel';
import { CheckForm } from '../../../../../shared/models/view/DamageCheckForm';
import { PersonalDataFormModel } from './PersonalDataFormModel';
import { DocumentsBillsFormModel } from './DocumentsBillsFormModel';
import { DamageCostLimit } from '../../../../../shared/models/view/DamageCostLimit.enum';

/**
 * The application model that holds the data for the whole application.
 */
export class AppApplicationModel extends Application {
	private damageModel: DamageFormModel;
	private checkModel: CheckForm;
	private personalDataModel: PersonalDataFormModel;
	private documentsBillsModel: DocumentsBillsFormModel;
	private vorgangsnummer: string;
	private costLimit: DamageCostLimit;

	get CostLimit(): DamageCostLimit {
		return this.costLimit;
	}
	set CostLimit(value: DamageCostLimit) {
		this.costLimit = value;
	}

	set DamageFormModel(value: DamageFormModel) {
		this.damageModel = value;
	}

	get DamageFormModel(): DamageFormModel {
		return this.damageModel;
	}

	set DocumentsBillsFormModel(value: DocumentsBillsFormModel) {
		this.documentsBillsModel = value;
	}

	get DocumentsBillsFormModel(): DocumentsBillsFormModel {
		return this.documentsBillsModel;
	}

	set PersonalDataFormModel(value: PersonalDataFormModel) {
		this.personalDataModel = value;
	}

	get PersonalDataFormModel(): PersonalDataFormModel {
		return this.personalDataModel;
	}

	set CheckFormModel(value: CheckForm) {
		this.checkModel = value;
	}

	get CheckFormModel(): CheckForm {
		return this.checkModel;
	}

	set Vorgangsnummer(value: string) {
		this.vorgangsnummer = value;
	}

	get Vorgangsnummer(): string {
		return this.vorgangsnummer;
	}

	public mergeWithUser(user: User, baseDataEditable: boolean): AppApplicationModel {
		if (user && user.Valid) {
			if (!this.PersonalDataFormModel) {
				this.PersonalDataFormModel = new PersonalDataFormModel();
			}
			this.PersonalDataFormModel.PersoenlicheDaten.mergeWithUser(user, baseDataEditable);
		}
		return this;
	}



	/**
		 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
		 */
	public static createFromObject(dataObject: { [key: string]: any }): AppApplicationModel {
		return AppUtils.Helper.createFromMap(dataObject, AppApplicationModel, (key: string, value: any) => {
			switch (key) {
				case 'damageModel':
					return DamageFormModel.createFromObject(value);
				case 'documentsBillsModel':
					return DocumentsBillsFormModel.createFromObject(value);
				case 'personalDataModel':
					return PersonalDataFormModel.createFromObject(value);
				case 'checkModel':
					return CheckForm.createFromObject(value);
				default:
					return value;
			}
		});
	}

}
